<div class="header-wrapper">
  <div class="header-content">
      <a [href]="'https://kimba.tv/'" target="_blank">
         <mat-icon [svgIcon]="'logo'" style="height: 40px; width: 40px;"></mat-icon>
    </a>
    <div class="header-icons">
   <a [href]="'https://discord.gg/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'discord'"></mat-icon>
    </a>
    <a [href]="'https://www.youtube.com/@k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'youtube'"></mat-icon>
    </a>
    <a [href]="'https://x.com/k1m6a'" target="_blank">
       <mat-icon [svgIcon]="'x'"></mat-icon>
    </a>
    <a [href]="'https://twitch.tv/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'twitch'"></mat-icon>
    </a>
    <a [href]="'https://lnx.kimba.tv/merch'" target="_blank">
        <mat-icon [svgIcon]="'merch'"></mat-icon>
    </a>
    </div>
  </div>
</div>
<div class="content-wrapper">
    <h1 class="main-title">Giveaway information & Winners</h1>
    <h2>How to win giveaway </h2>

    <div class="steps-container">
        <div class="giveaway-step">
          <img src="/assets/icons/step-1.png" alt="">
          <p>Sign up for the exchanges using the referral links below.</p>
        </div>
        <div class="giveaway-step">
          <img src="/assets/icons/step-2.png" alt="">
          <p>After signing up, take your UID from the exchange and update it in your Kimba.TV dashboard profile</p>
        </div>
        <div class="giveaway-step">
          <img src="/assets/icons/step-3.png" alt="">
          <p>Show up on stream during the Giveaways and participate!</p>
        </div>
    </div>
    
    <h2 class="exchanges-title">Exchanges</h2>
  <div class="exchanges-container">
  <div class="column" *ngFor="let col of exchangeColumns()">
    
      <a  *ngFor="let exchange of col" class="exchange-item" [href]="exchange.url" target="_blank">
        <mat-icon [svgIcon]="exchange.name"></mat-icon>
        {{ exchange.name }}
      </a>
  </div>
</div>

  <!-- Новая секция с таблицей победителей -->
  <h2 class="winners-title">Over $1 million+ given away to:</h2>
  <div class="winners-table-container">
    @if (winners()?.winners?.length) {
      <table mat-table [dataSource]="winners()?.winners!" class="winners-table">
         <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let winner; let i = index">
          {{ calculatePosition(i) }}
        </td>
      </ng-container>
        <!-- Колонка с именем пользователя -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef>Username</th>
          <td mat-cell *matCellDef="let winner">{{ winner.username }}</td>
        </ng-container>

        <!-- Колонка с суммой выигрыша -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let winner">${{ winner.amount }}</td>
        </ng-container>

        <!-- Колонка с биржей -->
        <ng-container matColumnDef="exchange_name">
          <th mat-header-cell *matHeaderCellDef>Exchange</th>
          <td mat-cell *matCellDef="let winner">{{ winner.exchange_name }}</td>
        </ng-container>

        <!-- Колонка с датой -->
        <ng-container matColumnDef="date_won">
          <th mat-header-cell *matHeaderCellDef>Date Won</th>
          <td mat-cell *matCellDef="let winner">{{ winner.date_won | dateFormat}}</td>
        </ng-container>

        <!-- Колонка с платформой -->
        

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      
    } @else {
      <div class="no-winners">
        No winners yet. Be the first to win!
      </div>
    }
    <div class="paginator">
      <div>
        Showed 20 per page
      </div>
      <div class="pages-container">
        {{countListPosition()}}
        <mat-icon [svgIcon]="'left-arrow'" (click)="prevPage()" ></mat-icon>
        <div class="page-numbers">
          <span class="active">
            {{paginatorSignal().currentPage}}
          </span>
          <span class="page-number" (click)="loadWinners(paginatorSignal().currentPage! + 1)">
            @if( paginatorSignal().currentPage! + 1 <=  paginatorSignal().pages! ) {
            {{paginatorSignal().currentPage! + 1}}
          }
          </span>
          <span class="page-number" (click)="loadWinners(paginatorSignal().currentPage! + 2)">
            @if( paginatorSignal().currentPage! + 2 <=  paginatorSignal().pages! ) {
            {{paginatorSignal().currentPage! + 2}}
          }
          </span>
        </div>
        
        
        
        
       
        <mat-icon [svgIcon]="'right-arrow'"(click)="nextPage()"></mat-icon>
      </div>
    </div>
  </div>
</div>
<div class="footer-wrapper">
  <div class="header-content">
    <a [href]="'https://app.k1m6a.tv/'" target="_blank" style="color: white; text-decoration: none;">
         © 2026 Kimba.TV
    </a>
    <div class="header-icons">
    
   <a [href]="'https://discord.gg/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'discord'"></mat-icon>
    </a>
    <a [href]="'https://www.youtube.com/@k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'youtube'"></mat-icon>
    </a>
    <a [href]="'https://x.com/k1m6a'" target="_blank">
       <mat-icon [svgIcon]="'x'"></mat-icon>
    </a>
    <a [href]="'https://twitch.tv/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'twitch'"></mat-icon>
    </a>
    <a [href]="'https://lnx.kimba.tv/merch'" target="_blank">
        <mat-icon [svgIcon]="'merch'"></mat-icon>
    </a>
    </div>
  </div>
</div>
